// src/hooks/productTypes/useGetProductTypesEnumValues.js
import { useQuery } from "@tanstack/react-query";
import { getProductTypesEnumValues } from "../../api/apiProductTypes";
import i18next from "i18next";

const useGetProductTypesEnumValues = () => {
    const { data, isLoading, error, refetch, isFetching } = useQuery({
        queryKey: ["productTypesEnumValues", i18next.language],
        queryFn: () => getProductTypesEnumValues(),
    });

    const enumValues = data?.data || [];

    return { enumValues, isLoading, error, refetch, isFetching };
};

export default useGetProductTypesEnumValues;
